import ViralLoopsFormWidget from './ViralLoopsFormWidget';

function JoinWaitlistButton(user) {
  function customButtonTrigger() {
    if (window.ViralLoops) {
      if(user){
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("email", user.email);
        newUrl.searchParams.set("FirstName", user.firstname);
        newUrl.searchParams.set("LastName", user.lastname);
    
        // Push the updated URL to the browser history without reloading
        window.history.pushState({}, "", newUrl);
      }
      window.ViralLoops.getCampaign().then((c) => {
        console.log(c);
        c.customButtonTrigger();
      });
    }
  }

  return (
    <>
      <button className="btn joinWaitBtn vrlps-trigger" onClick={customButtonTrigger}>
        Join Waitlist
      </button>
      <ViralLoopsFormWidget ucid="1YpCtrfhAfErgPgbFKOkIWrTb8s" popup={true} />
    </>
  );
}

export default JoinWaitlistButton;
